/**
 * * Проверить валидная ли строка Base64
 * @param base64
 * @returns
 */
export const isValidBase64 = (base64: string): boolean => {
  const regex = /^data:\w+\/[a-zA-Z\+\-\.]+;base64,[A-Za-z0-9+/]+={0,2}$/;
  return regex.test(base64);
};
